"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGameInfoBar3 = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _PixiWinCounter = require("./PixiWinCounter");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiGameInfoBar3 = exports.PixiGameInfoBar3 = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiGameInfoBar3(componentName, position, textStyle, bmFontStyle) {
    var _this;
    var backgroundSprite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "info_bg.png";
    var showerConfig = arguments.length > 5 ? arguments[5] : undefined;
    var counterBg = arguments.length > 6 ? arguments[6] : undefined;
    var showerSprites = arguments.length > 7 ? arguments[7] : undefined;
    _classCallCheck(this, PixiGameInfoBar3);
    _this = _callSuper(this, PixiGameInfoBar3, [componentName, position]);
    _defineProperty(_this, "_instantiated", void 0);
    _defineProperty(_this, "_background", void 0);
    _defineProperty(_this, "infoText", void 0);
    _defineProperty(_this, "idleContainer", void 0);
    _defineProperty(_this, "specialMessageActive", void 0);
    _defineProperty(_this, "idles", void 0);
    _defineProperty(_this, "lastStatus", void 0);
    _defineProperty(_this, "winXValue", void 0);
    _defineProperty(_this, "winXAnchorValue", 0);
    _defineProperty(_this, "currentIdleSprite", 0);
    _defineProperty(_this, "preSpecialMessage", void 0);
    _defineProperty(_this, "IDLE_NEXT_TIME", 6000);
    _defineProperty(_this, "_nextIdleInterval", void 0);
    _defineProperty(_this, "_channel", void 0);
    _defineProperty(_this, "_startedDisabled", void 0);
    _defineProperty(_this, "_hideWinText", void 0);
    _defineProperty(_this, "_counter", void 0);
    _defineProperty(_this, "_counterBg", void 0);
    _defineProperty(_this, "_hyperSpinActive", void 0);
    _defineProperty(_this, "infoTextHidden", void 0);
    _this.idles = [];
    _this._channel = _core.CORE.getState().config.channel;
    _this.winXValue = 60;
    _this._background = new _pixi.Sprite(_pixi.Texture.from(backgroundSprite));

    // by default we force WIN not to show on mobile
    if (_this._channel == _core.Channel.Mobile) _this._hideWinText = true;

    //#region text, used for GOOD LUCK and WIN
    _this.infoText = new _pixi.Text("", textStyle);
    _this.infoText.resolution = 2;
    _this.infoText.anchor.set(0.5, 0.5);
    _this.infoText.alpha = 0;
    //#endregion

    //#region idle container
    _this.idleContainer = new _pixiGame.CustomPixiContainer();
    _this.idleContainer.name = "IdleContainer";
    _this.idleContainer.alpha = 0;
    //#endregion

    //#region counter
    _this._counter = new _PixiWinCounter.PixiWinCounter(componentName + "WinCounter", bmFontStyle, showerConfig, showerSprites);
    _this._counter.x = _this.width / 2;
    if (counterBg) {
      _this._counterBg = new _pixi.Sprite(_pixi.Texture.from(counterBg));
      _this._counterBg.anchor.set(0.5);
      _this._counterBg.scale.set(3);
      _this._counterBg.x = 4;
      _this._counterBg.y = 2;
      _this._counterBg.alpha = 1;
      //this and the counter is separated from the shower, to avoid shower fading out
      _this._counter.addCounterBackGround(_this._counterBg);
    }

    //#endregion

    _core.CORE.subscribe('infoBar.state', _this.handleInfoState.bind(_this));
    _core.CORE.subscribe('game.winCounter', _this.counterUpdate.bind(_this));
    _core.CORE.subscribe('game.hyperSpin', function (a) {
      return _this._hyperSpinActive = a;
    });
    _this._instantiated = true;
    _this.addChild(_this._background, _this.infoText, _this.idleContainer, _this._counter);
    return _this;
  }

  /**
   * Show next idle sprite/display object
   */
  _inherits(PixiGameInfoBar3, _PixiGameComponent);
  return _createClass(PixiGameInfoBar3, [{
    key: "nextIdleSprite",
    value: function nextIdleSprite() {
      if (this.idles[this.currentIdleSprite % this.idles.length].stop) setTimeout(this.idles[this.currentIdleSprite % this.idles.length].stop.bind(this.idles[this.currentIdleSprite % this.idles.length]), 1);
      this.idles[this.currentIdleSprite % this.idles.length].visible = false;
      this.currentIdleSprite++;
      this.idles[this.currentIdleSprite % this.idles.length].visible = true;
      if (this.idles[this.currentIdleSprite % this.idles.length].start) {
        // setTimeout Hack, think its due to spine not agreeing to start the animation until its visible.
        setTimeout(this.idles[this.currentIdleSprite % this.idles.length].start.bind(this.idles[this.currentIdleSprite % this.idles.length]), 1);
      }
    }

    /**
     * Obsolete
     * old "standard" of generating images with text or just text to be an image.
     * 
     * @param translationKey 
     * @param textStyle 
     * @param textureName 
     * @param textY 
     * @returns 
     */
  }, {
    key: "generateIdleSprite",
    value: function generateIdleSprite(translationKey, textStyle, textureName) {
      var textY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var container = new _pixiGame.CustomPixiContainer();
      var string = _core.CORE.translate(translationKey);
      if (textureName) {
        var t = string.split('{0}');
        var p1, p2;
        p1 = new _pixi.Text(t[0], textStyle);
        p1.anchor.set(0, 0.5);
        var s1 = new _pixi.Sprite(_pixi.Texture.from(textureName));
        s1.height = p1.height;
        s1.scale.set(s1.scale.y);
        container.addChild(s1);
        p1.y = s1.height / 2;
        p1.resolution = 2;
        container.addChild(p1);
        s1.x = p1.width + 6;
        p2 = new _pixi.Text(t[1], textStyle);
        p2.anchor.set(0, 0.5);
        p2.x = s1.x + s1.width + 6;
        p2.resolution = 2;
        p1.y = s1.height / 2;
        p2.y = s1.height / 2;
        container.addChild(p2);
      } else {
        var _p = new _pixi.Text(string, textStyle);
        container.addChild(_p);
      }
      var renderTexture = _pixi.RenderTexture.create({
        width: container.width,
        height: container.height,
        resolution: 2
      });
      this.application.renderer.render(container, {
        renderTexture: renderTexture
      });
      var s = new _pixi.Sprite(renderTexture);
      s.visible = false;
      s.anchor.set(0.5);
      return s;
    }

    /**
     * Set a special message. can be used for games with features where we want to add this.
     * @param msg 
     */
  }, {
    key: "specialMessage",
    value: function specialMessage(msg) {
      this.specialMessageActive = true;
      this.preSpecialMessage = this.infoText.text;
      this.infoText.text = msg;
      this.infoText.x = this._background.width / 2;
      this.infoText.anchor.x = 0.5;
      _gsap["default"].killTweensOf(this.infoText);
      this.infoText.alpha = 1;
      _gsap["default"].to(this.infoText, {
        alpha: 0.4,
        repeat: -1,
        yoyo: true,
        duration: 0.4
      });
      this._counter.hide(false, false);
    }

    /**
     * Turn of the special message.
     */
  }, {
    key: "specialMessageOff",
    value: function specialMessageOff() {
      _gsap["default"].killTweensOf(this.infoText);
      this.specialMessageActive = false;
      if (!this._hideWinText) {
        this.infoText.alpha = 1;
        // we always go back to "wun here since counter will show"
        this.infoText.text = _core.CORE.translate('statusText' + 4);
        this.infoText.x = this.winXValue;
        this.infoText.anchor.x = this.winXAnchorValue;
      } else {
        this.infoText.alpha = 0;
      }
      this._counter.show(false);
    }
  }, {
    key: "counterUpdate",
    value: function counterUpdate(coinsWon) {
      if (this.specialMessageActive) return;
      if (coinsWon > 0) {
        this.infoText.x = this.winXValue;
        this.infoText.anchor.x = this.winXAnchorValue;
        if (this._hideWinText) this.infoText.text = '';else this.infoText.text = _core.CORE.translate('statusText3'); // this is due to change in enum order... not great but dont want to break translations

        // if hyper spin, dont fadeIn/animate the show part
        this._counter.setCounter(coinsWon, this._hyperSpinActive ? 0.1 : 0.3, !this._hyperSpinActive);
      } else if (coinsWon == 0) {
        this._counter.resetPrevious();
      }
    }
  }, {
    key: "handleInfoState",
    value: function handleInfoState(s) {
      if (s === undefined || this.specialMessageActive) return;
      var fastPlay = _core.CORE.getState().config.fastPlay;
      this.idleHide(fastPlay);
      this.infoTextHide(fastPlay);
      switch (s) {
        case _core.GameInfoBarState.Empty:
          {
            //       console.log('new gameinfobar state EMPTY ' + s)
            this._counter.hide(!fastPlay, true);
            break;
          }
        case _core.GameInfoBarState.Win:
          {
            //       console.log('new gameinfobar state WIN ' + s)
            if (!this._hideWinText) this.infoTextShow(fastPlay);
            break;
          }
        case _core.GameInfoBarState.Ended:
          {
            //        console.log('new gameinfobar state ENDED ' + s)
            break;
          }
        case _core.GameInfoBarState.Idle:
          {
            //        console.log('new gameinfobar state IDLE ' + s)
            this._counter.hide(!fastPlay, true);
            this.idleShow();
            break;
          }
        case _core.GameInfoBarState.Started:
          {
            //      console.log('new gameinfobar state STARTED ' + s)
            this.infoText.x = this._background.width / 2;
            this.infoText.anchor.x = 0.5;
            this._counter.hide(!fastPlay, true);
            if (!this._startedDisabled) {
              this.infoText.text = _core.CORE.translate('statusText' + s);
              this.infoTextShow(fastPlay);
            }
            break;
          }
        case _core.GameInfoBarState.Reconnect:
          {
            if (_core.CORE.getState().game.winCounter > 0) this.counterUpdate(_core.CORE.getState().game.winCounter);else {
              if (!this._hideWinText) this.infoTextShow(fastPlay);
            }
            break;
          }
        default:
          {
            //      console.log('new gameinfobar state DEFAULT ' + s)
            this.infoTextShow(fastPlay);
            this.infoText.x = this._background.width / 2;
            this.infoText.anchor.x = 0.5;
            this._counter.hide(true, true);
            this.infoText.text = _core.CORE.translate('statusText' + s);
            break;
          }
      }
      this.lastStatus = s;
    }
  }, {
    key: "onResize",
    value: function onResize(s) {
      if (!this._instantiated) return;
      this.infoText.x = this._background.width / 2;
      this.infoText.anchor.x = 0.5;
      this.infoText.y = this._background.height / 2;
      if (this.lastStatus === _core.GameInfoBarState.Win) {
        this.infoText.x = this.winXValue;
        this.infoText.anchor.x = this.winXAnchorValue;
      }
      this.idleContainer.x = this._background.width / 2;
      this.idleContainer.y = this._background.height / 2 + 8;
      _superPropGet(PixiGameInfoBar3, "onResize", this, 3)([s]);
    }

    /**
     * Add objects to be shown, usually image and text.
     * @param displayObject 
     */
  }, {
    key: "addIdle",
    value: function addIdle(displayObject) {
      displayObject.visible = false;
      this.idleContainer.addChild(displayObject);
      this.idles.push(displayObject);
    }
  }, {
    key: "idleShow",
    value: function idleShow() {
      // if already showing, ignore
      if (this.idleContainer.alpha == 1) return;
      _gsap["default"].killTweensOf(this.idleContainer);
      this.idleContainer.alpha = 0;
      _gsap["default"].to(this.idleContainer, {
        duration: 0.2,
        alpha: 1
      });

      // if no idles exist. 
      if (this.idles.length < 1) return;
      this.idles[this.currentIdleSprite % this.idles.length].visible = true;
      if (this._nextIdleInterval != undefined) window.clearInterval(this._nextIdleInterval);
      this._nextIdleInterval = window.setInterval(this.nextIdleSprite.bind(this), this.IDLE_NEXT_TIME);
    }
  }, {
    key: "idleHide",
    value: function idleHide(fastPlay) {
      _gsap["default"].killTweensOf(this.idleContainer);

      // if already hidden, ignore
      if (this.idleContainer.alpha == 0) return;
      if (!fastPlay) {
        this.idleContainer.alpha = 1;
        _gsap["default"].to(this.idleContainer, {
          duration: 0.2,
          alpha: 0
        });
      } else {
        this.idleContainer.alpha = 0;
      }
    }
  }, {
    key: "infoTextShow",
    value: function infoTextShow(fastPlay) {
      if (!this.infoTextHidden) return;
      this.infoTextHidden = false;
      _gsap["default"].killTweensOf(this.infoText);
      if (!fastPlay) {
        this.infoText.alpha = 0;
        _gsap["default"].to(this.infoText, {
          duration: 0.2,
          alpha: 1
        });
      } else {
        this.infoText.alpha = 1;
      }
    }
  }, {
    key: "infoTextHide",
    value: function infoTextHide(fastPlay) {
      if (this.infoTextHidden) return;
      this.infoTextHidden = true;
      _gsap["default"].killTweensOf(this.infoText);
      if (!fastPlay) {
        this.infoText.alpha = 1;
        _gsap["default"].to(this.infoText, {
          duration: 0.2,
          alpha: 0
        });
      } else {
        this.infoText.alpha = 0;
      }
    }

    /**
     * Hide the GameInfoBar
     * 
     * @param instant if it should skip animation
     */
  }, {
    key: "hide",
    value: function hide(instant) {
      _gsap["default"].killTweensOf(this);
      if (instant) this.alpha = 0;
      _gsap["default"].to(this, {
        alpha: 0,
        duration: 0.5
      });
    }

    /**
     * 
     * Show the GameInfoBar
     * @param instant if it should skip animation
     */
  }, {
    key: "show",
    value: function show(instant) {
      _gsap["default"].killTweensOf(this);
      if (instant) this.alpha = 1;
      if (this.alpha != 1) {
        _gsap["default"].to(this, {
          alpha: 1,
          duration: 0.5
        });
      }
    }

    /**
     * If the background should not show. used for some games in mobile mode.
     */
  }, {
    key: "hideBackground",
    value: function hideBackground() {
      // background is used to calculate posistion so we do not remove it or set visible false
      this._background.alpha = 0;
    }

    /**
     * Do not display "GOOD LUCK!" when spin starts, also used in mobile on some games where good luck is in the UI bar.
     */
  }, {
    key: "disableStartingMessage",
    value: function disableStartingMessage() {
      this._startedDisabled = true;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiGameInfoBar3.js.map